import { useMsal } from "@azure/msal-react";
import { useEffect } from "react";

const LogoutPage = () => {
  const { instance, inProgress } = useMsal();

  useEffect(() => {
    instance.logoutRedirect({
      postLogoutRedirectUri: "http://localhost:3000/",
    });
  }, [inProgress]);

  return <p>Logging out...</p>;
};

export default LogoutPage;
